import { unique } from '../../util/array';

// TODO: Simplify this function after next major release: only handle model.events
export function getModelEvents(model) {
    const events = [...(model?.events || [])];
    // Handle legacy event date
    const formatEvents = (itemsObject, parentEventName = '') => {
        Object.keys(itemsObject || {}).forEach((eventName, index) => {
            if(Array.isArray(itemsObject[eventName])) {
                // console.log('getModelEvents::: sub recursive array', parentEventName, eventName, itemsObject[eventName]);
                const extraInformation = {};
                if(parentEventName === 'pagesAccess') {
                    extraInformation.page = eventName;
                }
                itemsObject[eventName].forEach(subItem => {
                    events.push({
                        name: parentEventName || eventName,
                        date: subItem,
                        ...extraInformation,
                    });
                });
            } else if(typeof itemsObject[eventName] === 'object') {
                // console.log('getModelEvents::: sub recursive object', parentEventName, eventName, itemsObject[eventName]);
                formatEvents(itemsObject[eventName], parentEventName || eventName);
            } else {
                events.push({
                    name: parentEventName || eventName,
                    date: itemsObject[eventName],
                });
            }
        });
    };

    formatEvents(model?.dates || {});
    // console.log('getModelEvents', applicant, events);
    return unique(events, event => `${event.name}/${event.date}`);
}

export function getModelEvent(model, eventName, mode = 'last') {
    const events = getModelEvents(model);
    if(events?.length) {
        let method = '';
        switch(mode) {
            case 'last':
                method = 'findLast';
                break;

            case 'first':
                method = 'find';
                break;

            default:
                method = 'filter';
        }
        return events[method](event => event.name === eventName);
    }
    return null;
}
